import {
  GlobalCard,
  GlobalCardBody,
  GlobalCardHeader,
  GlobalCardHeaderTitle,
} from '@global-engineering-shared/gweb-material-lab';
import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React, { useState } from 'react';

import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import CheckboxToggleGroup from 'components/CheckboxToggleGroup';
import FrameHealthTabs from 'features/Health/components/FrameHealthTabs';
import { frameHealthTabValues } from 'features/Health/components/FrameHealthTabs/utils/frameHealthTabValues';
import { initialFrameHealthToggleState } from 'features/Health/containers/FrameHealthChartContainer/utils/initialFrameHealthToggleState';

import useStyles from './FrameHealthContainer.styles';

const FrameHealthContainer = () => {
  const classes = useStyles();
  const [toggles, setToggles] = useState<Toggle[]>(initialFrameHealthToggleState);

  const getTitleComponent = () => () =>
    (
      <div className={classes.title}>
        <Typography variant="h3" fontWeight="600">
          Live Frame Health by Verticals
        </Typography>
        <CheckboxToggleGroup toggles={toggles} setToggles={setToggles} />
      </div>
    );

  return (
    <GlobalCard className={classes.root}>
      <GlobalCardHeader className={classes.header}>
        <GlobalCardHeaderTitle TitleComponent={getTitleComponent()} />
      </GlobalCardHeader>
      <GlobalCardBody>
        <FrameHealthTabs tabs={frameHealthTabValues} toggles={toggles} />
      </GlobalCardBody>
    </GlobalCard>
  );
};

export default FrameHealthContainer;
